import { Controller } from "@hotwired/stimulus"

// A list row that opens its record (the person or the company) when clicked
// anywhere outside its own links and buttons. The row's first cell holds the
// same link for the keyboard and screen readers; selecting text does not
// navigate, and a Cmd/Ctrl-click opens a new tab.
export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (!this.urlValue) return
    if (event.target.closest("a, button, input, select, textarea, summary, label, details")) return
    if (window.getSelection && window.getSelection().toString() !== "") return

    if (event.metaKey || event.ctrlKey) {
      window.open(this.urlValue, "_blank", "noopener")
    } else if (window.Turbo) {
      window.Turbo.visit(this.urlValue)
    } else {
      window.location.assign(this.urlValue)
    }
  }
}
